import getCombatantLastRoundAction from './getCombatantLastRoundAction'

export default function getCombatantLastRoundActionImage(combatant, maxCA) {
  return getCombatantLastRoundAction(combatant, maxCA).image
}
